/* NPFC tabs: one small ARIA tabs controller for every tab system on the site
   (the B2B enquiry module and the Commercial information rail).

   Progressive enhancement. The server renders every panel visible, in document order, with the
   tablist hidden. This script un-hides the tablist and hides the inactive panels, so without
   JavaScript, and for crawlers, all of the content is on the page and readable.

   Markup contract
     <div data-npfc-tabs [data-tabs-stack]>
       <div role="tablist" hidden> <button role="tab" id aria-controls aria-selected data-tab-key data-tab-alias="a b"> ...
       <div role="tabpanel" id aria-labelledby> ...
     data-tab-key    stable key used by NPFC_TABS.select(root, key) and by events
     data-tab-alias  space separated URL hashes (without #) that select this tab
   Behaviour: click, Left/Right/Up/Down/Home/End, roving tabindex, activation follows focus
   (two or six short panels, nothing expensive), hash aliases on load and on hashchange, and a
   bubbling "npfc:tabchange" event. data-tabs-stack keeps inactive panels laid out but invisible on
   wide screens so the section does not change height when a tab is chosen (CSS does that part).
   Nothing here depends on hover.                                                                  */
(function () {
  if (window.NPFC_TABS) return;

  function init(root) {
    if (!root || root.__npfcTabs) return;
    var list = root.querySelector('[role="tablist"]');
    if (!list) return;
    var tabs = [].slice.call(list.querySelectorAll('[role="tab"]'));
    if (tabs.length < 2) return;
    var panels = tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
    if (panels.some(function (p) { return !p; })) return;
    root.__npfcTabs = true;
    var current = -1;

    function keyOf(t) { return t.getAttribute('data-tab-key') || t.id; }
    function select(i, source, focus) {
      if (i < 0 || i >= tabs.length) return;
      var changed = i !== current;
      current = i;
      tabs.forEach(function (t, n) {
        var on = n === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        t.classList.toggle('is-active', on);
        panels[n].hidden = !on;
        panels[n].classList.toggle('is-active', on);
      });
      if (focus) tabs[i].focus();
      if (changed) {
        root.dispatchEvent(new CustomEvent('npfc:tabchange', { bubbles: true, detail: { root: root, key: keyOf(tabs[i]), index: i, tab: tabs[i], panel: panels[i], source: source || 'api' } }));
      }
    }
    function indexOfKey(key) {
      for (var i = 0; i < tabs.length; i++) if (keyOf(tabs[i]) === key) return i;
      return -1;
    }
    function indexOfHash(h) {
      h = (h || '').replace(/^#/, '');
      if (!h) return -1;
      for (var i = 0; i < tabs.length; i++) {
        var al = (tabs[i].getAttribute('data-tab-alias') || '').split(/\s+/);
        if (al.indexOf(h) > -1 || tabs[i].id === h || panels[i].id === h) return i;
      }
      return -1;
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, 'click'); });
      t.addEventListener('keydown', function (e) {
        var n = tabs.length, k = e.key, to = -1;
        if (k === 'ArrowRight' || k === 'ArrowDown') to = (i + 1) % n;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') to = (i - 1 + n) % n;
        else if (k === 'Home') to = 0;
        else if (k === 'End') to = n - 1;
        if (to < 0) return;
        e.preventDefault();
        select(to, 'keyboard', true);
      });
    });

    list.hidden = false;
    root.classList.add('is-tabs');

    var start = indexOfHash(location.hash);
    if (start < 0) {
      for (var s = 0; s < tabs.length; s++) if (tabs[s].getAttribute('aria-selected') === 'true') { start = s; break; }
    }
    select(start < 0 ? 0 : start, 'init');
    window.addEventListener('hashchange', function () {
      var h = indexOfHash(location.hash);
      if (h > -1) select(h, 'hash');
    });

    root.npfcTabs = {
      select: function (key, source) { var i = indexOfKey(key); if (i > -1) select(i, source || 'api'); return i > -1; },
      current: function () { return keyOf(tabs[current]); },
      tabs: tabs, panels: panels
    };
  }

  function initAll(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-npfc-tabs]'), init);
  }

  window.NPFC_TABS = {
    init: init,
    initAll: initAll,
    select: function (root, key, source) { init(root); return root && root.npfcTabs ? root.npfcTabs.select(key, source) : false; }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  // Sections re-rendered by the theme editor
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
